<template>
  <div class="cbox">
    <div class="w_100 h_100 bcontent flexStart borderbox" style="padding:20px 0;">
      <div class="h_100"
           style="flex-shrink:0;width:250px; overflow:auto; background-color:#E8EDF8;border-radius:4px;">
        <div class="w_100" style="background-color:#E8EDF8;border-radius:4px;">
          <div :class="['school', schoolId == 'all' ? 'ckd' : '']" @click="setSchool('all')">全部学校</div>
          <div :class="['school', schoolId == item.id ? 'ckd' : '']" @click="setSchool(item.id)"
               v-for="(item, idx) in SchoolList" :key="idx">{{ item.platform }}<!--<i v-if="!item.hasData"
							class="el-icon-star-on" style="color:orangered"></i>--></div>
        </div>

      </div>
      <div class="flex_1 h_100 ml20 flexCloumn" style="overflow:auto;">
      <div class="w_100 headbar flexBetween" style="padding:0;border:0;">
        <div class="flexStart">
          <el-select v-model="searchForm.major_type" size="small" placeholder="专业大类" clearable style="margin-right: 10px;" @change="getlist">
            <el-option v-for="(mtype,index) in majorTypes" :label="mtype" :value="mtype" :key="index"></el-option>
          </el-select>
          <el-input v-model="searchForm.keyword" size="small" clearable placeholder="工种名称/等级/发证单位"></el-input>
          <el-button type="primary" size="small" icon="el-icon-search" @click="getlist">搜索</el-button>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="dialogVisible = true">导入
          </el-button>
        </div>
      </div>
      <el-table :data="dataList" height="100%" size="small" stripe border style="width:fit-content;width:100%;">
        <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
        <el-table-column prop="school_name" label="学校名称" ></el-table-column>
        <el-table-column prop="major_type" label="专业大类" ></el-table-column>
        <el-table-column prop="major_name" label="专业名称"></el-table-column>
        <el-table-column prop="zydm" label="专业代码" ></el-table-column>
        <el-table-column prop="cert_name" label="工种名称"></el-table-column>
        <el-table-column prop="level" label="等级" ></el-table-column>
        <el-table-column prop="fzdw" label="发证单位"></el-table-column>
      </el-table>
      <el-pagination @current-change="handlePageChange" @size-change="handleSizeChange"
                     :current-page="page.current_page" :page-size="page.per_page" :total="page.count"
                     layout="total, sizes,prev, pager, next" :page-sizes="[10, 20, 50, 100]" style="margin-top: 10px;">
      </el-pagination>
      </div>
    </div>

    <!--    查看-->
    <el-dialog class="cus_dialog " title="班级性质" :visible.sync="dialogVisible" :close-on-click-modal="false"
               width="600px" height="30%">
      <div style="line-height: 50px;">
        <a href="/xls/技能鉴定证书导入模板.xlsx" target="_blank">技能鉴定证书导入模板下载（excel/xls）</a>
      </div>
      <div style="line-height: 50px; color:orangered">
        请严格按照模板格式填入正确的数值
      </div>

      <div style="text-align:right">
        <el-upload style="display: inline-block; margin-right: 20px;" action="" :http-request="uploadTemp"
                   :on-success="uploadFiles" :show-file-list="false" name="image" accept=".xls,.xlsx">
          <el-button icon="el-icon-upload" type="primary" style="margin-left:100px"
                     size="small">选择文件</el-button>
        </el-upload>
      </div>
    </el-dialog>
    </div>
</template>

<script>
export default {
  components: { },
  data() {
    return {
      dialogVisible: false,
      target_teachers: "",
      target_classes: "",
      choosedTeachers: 0,
      choosedClasses: 0,
      choosedStuCount: 0,
      choosedParentCount: 0,
      hasteacher: false,
      showAnswer: false,

      page: {
        count: 0,
        current_page: 1,
        per_page: 50,
        total_page: 0
      },

      dataList: [],
      formData: {},
      ruleForm: {
        sort: 1,
        formal: 1,
        open: 0,
        moban_arr: [{
          type: 0,
          send_type: 2,
          checkAll: true,
          isIndeterminate: false,
          selectCoList: [],
        }],
      },
      // isIndeterminate: false,
      // checkAll: true,
      showDialog_co: false,
      coList: [],
      indexCo: 0,
      // selectCoList:[],
      colorList: ['#67c23a', '#f56c6c', '#409eff',],
      rules: {
        plan_name: [{
          required: true,
          message: "请输入计划名称",
          trigger: "blur"
        },],
        sta_end_time: [{
          required: true,
          message: "请选择调查时段",
          trigger: "blur"
        },],
        formal: [{
          required: true,
          message: "请选择发布状态",
          trigger: "blur"
        },],
      },
      showDialog: false,
      showSms: false,
      dialodTitle: '问卷计划新增',
      moban_list00: [], //学生
      moban_list02: [], //企业
      moban_list01: [], //家长
      props: {
        multiple: true,
        emitPath: false,
        value: 'id',
        label: 'stu_name'
      },

      studentsTree: [],
      showDialog_preview: false,
      showDialog_complete: false,
      viewTitle: '',
      showDialog_report2: false,
      reportTitle: '',
      active_report: 'first',
      tempList: [],
      ids: [],
      tmOne: {},

      list: [],
      gkInfo: {},
      tjTmlist: [],
      hasXX: false,
      wordsList: [],
      ckdViewIvstID: [],
      plan_id: 0,
      completeList: [],
      defaultProps: {
        children: 'arr',
        label: 'name'
      },
      rateList: [],
      expandedKeys: [],
      teacherInfo: {},
      showJoinReport: false,
      showJoinReportEnt: false,
      showDialog_report: false,
      ckdTmrow: 0,
      ckdTmTitle: "",
      gyears: [],
      answers: [],
      selectRow: [],
      schoolList: [],
      searchForm: {
        npmid: "",
      },
      SchoolList: [],
      schoolId: 'all',
      majorTypes: [
        "农林牧渔大类",
        "资源环境与安全大类",
        "能源动力与材料大类",
        "土木建筑大类",
        "水利大类",
        "装备制造大类",
        "生物与化工大类",
        "轻工纺织大类",
        "食品药品与粮食大类",
        "交通运输大类",
        "电子与信息大类",
        "医药卫生大类",
        "财经商贸大类",
        "旅游大类",
        "文化艺术大类",
        "新闻传播大类",
        "教育与体育大类",
        "公安与司法大类",
        "公共管理与服务大类"
      ]
    };
  },
  mounted() {
    // console.log(sessionStorage.getItem("auth"));
    this.getInfo()
    this.getlist();
    this.getSchoolList()
    //this.getStudentsTree()
  },
  methods: {
    getInfo() {
      this.$http.post("/api/get_teacher_info").then(res => {
        this.teacherInfo = res.data
      })
    },
    expandedTree(data) {
      this.expandedKeys = [];
      for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].arr.length; j++) {
          this.expandedKeys.push(data[i].arr[j].name);//循环data的数据，把对应要展开的节点name放入展开的数组中
        }
      }
    },
    getSchoolList() {
      this.$http.post("/api/school_list").then(res => {
        this.SchoolList = res.data
      })
    },
    getlist() {
      this.dataList = []
      this.$http
        .post("/api/jnjd_table", {
          page: this.page.current_page,
          pagesize: this.page.per_page,
          tpmid: this.schoolId,
          major_type: this.searchForm.major_type,
          keyword: this.searchForm.keyword,
        })
        .then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            let rData = res.data.data
            rData.map(a => {
              let str = ''
              if (a.moban_arr && a.moban_arr.length > 0) {
                a.moban_arr.map(m => {
                  str += String(m.type)
                })
                // console.log(1111111, str)

                let a0 = '',
                  a1 = '',
                  a2 = ''
                if (str.indexOf('0') != -1) {
                  a0 = '学生'
                }
                if (str.indexOf('1') != -1) {
                  a1 = '家长'
                }
                if (str.indexOf('2') != -1) {
                  a2 = '企业'
                }
                a.send_typeStr = `${a0} ${a2} ${a1}`
              }

            })
            this.dataList = rData;

            this.page = res.data.page || this.page

            this.$nextTick(() => {
              // this.creatQrCode()
            })
          }
        });
    },
    uploadFiles(e) {
      let loadInstance = this.$loading({
        lock: true,
        text: '导入中....',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      })
      this.$http.post("/api/import_jnjd_table", {
        url: e.src,
        filename: e.fileName,
      }).then(res => {
        loadInstance.close()

        if (res.data.errors && res.data.errors.length > 0) {
          let html = ''
          for (let error of res.data.errors) {
            html += "<div style='font-size:13px'>" + error.msg + "</div>"
          }
          this.$alert(html, `未导入数据${res.data.errors.length}条`, {
            dangerouslyUseHTMLString: true,
            showCancelButton: true,
            cancelButtonText:"取消",
            distinguishCancelAndClose: true,
          });
        } else {
          this.$message.success("导入成功")
          this.dialogShow = false
          this.getlist()
        }

        this.dialogShow3 = false
        this.activeName = ""
        this.$nextTick(e => {
          this.activeName = "forth"
        })

      }).catch(e => {
        loadInstance.close();
      })
    },
    handlePageChange(page) {
      this.page.current_page = page
      this.getlist()
    },
    handleSizeChange(val) {
      this.page.current_page = 1;
      this.page.per_page = val;
      this.getlist()
    },
    setSchool(id) {
      this.schoolId = 0;
      this.tjData = null;
      this.searchForm.major_type = ""
      setTimeout(() => {
        this.schoolId = id
        this.getlist()
      }, 200)

    },
  }
};
</script>
<style type="text/less" lang="less" scoped>
.school {
  line-height: 30px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 10px;
}

.school:hover {
  background-color: aliceblue;

}

.ckd {
  background-color: #547df2;
  color: #fff;
}

.ckd:hover {
  background-color: #547df2;
  color: #fff;
}
</style>
